import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import {BrowserRouter, Route, Redirect, Switch} from "react-router-dom";
import "bootstrap/scss/bootstrap.scss";
import "assets/scss/paper-kit.scss?v=1.3.0";
import "aos/dist/aos.css";

// Lazy load routes for better performance
const Index = lazy(() => import("views/Index.js"));
const Work = lazy(() => import("views/Work"));
const AboutUs = lazy(() => import("views/AboutUs"));

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <BrowserRouter>
        <Suspense fallback={
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                backgroundColor: '#0b1011'
            }}>
                <div style={{ color: 'white', fontSize: '1.5rem' }}>Loading...</div>
            </div>
        }>
            <Switch>
                <Route
                    path="/work"
                    render={(props) => <Work {...props} />}
                />
                <Route
                    path="/about-us"
                    render={(props) => <AboutUs {...props} />}
                />
                <Route path="/" render={(props) => <Index {...props} />}/>
                <Redirect to="/"/>
            </Switch>
        </Suspense>
    </BrowserRouter>
);
